import { render, staticRenderFns } from "./GiftAidCheckbox.vue?vue&type=template&id=27760ab8&scoped=true"
import script from "./GiftAidCheckbox.vue?vue&type=script&lang=ts"
export * from "./GiftAidCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./GiftAidCheckbox.vue?vue&type=style&index=0&id=27760ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27760ab8",
  null
  
)

export default component.exports